import { createContext } from 'react';

export const StripeLoaderContext = createContext({ loaded: false, error: false });
export const StripeLoaderProvider = StripeLoaderContext.Provider;
